// Vendor imports
const qs = require('qs')
// Client V1 imports
const { send: ajax } = require('client/lib/request')
const { API: ArticleAPI } = require('client/models/article')
// Common Client V2 imports
const articleModelActions = require('client-v2/common/models/article/actions')
const { FetchStateEnum } = require('client-v2/common/utils/enums')

// Action types

const COLLECTIONS_FAILED = 'ARTICLE_PROFILE_SLIDE_COLLECTIONS_FAILED'
const COLLECTIONS_LOADED = 'ARTICLE_PROFILE_SLIDE_COLLECTIONS_LOADED'
const COLLECTIONS_LOADING = 'ARTICLE_PROFILE_SLIDE_COLLECTIONS_LOADING'
const COLLECTIONS_RESET = 'ARTICLE_PROFILE_SLIDE_COLLECTIONS_RESET'
const CURATOR_LOADED = 'ARTICLE_PROFILE_SLIDE_CURATOR_LOADED'
const INTERESTS_FAILED = 'ARTICLE_PROFILE_SLIDE_INTERESTS_FAILED'
const INTERESTS_LOADED = 'ARTICLE_PROFILE_SLIDE_INTERESTS_LOADED'
const INTERESTS_LOADING = 'ARTICLE_PROFILE_SLIDE_INTERESTS_LOADING'
const RELATED_FAILED = 'ARTICLE_PROFILE_SLIDE_RELATED_FAILED'
const RELATED_LOADED = 'ARTICLE_PROFILE_SLIDE_RELATED_LOADED'
const RELATED_LOADING = 'ARTICLE_PROFILE_SLIDE_RELATED_LOADING'
const SELECT_TAB = 'ARTICLE_PROFILE_SLIDE_SELECT_TAB'

// Action exports

module.exports = {
  // Types
  COLLECTIONS_FAILED,
  COLLECTIONS_LOADED,
  COLLECTIONS_LOADING,
  COLLECTIONS_RESET,
  CURATOR_LOADED,
  INTERESTS_FAILED,
  INTERESTS_LOADED,
  INTERESTS_LOADING,
  RELATED_FAILED,
  RELATED_LOADED,
  RELATED_LOADING,
  SELECT_TAB,
  // Actions
  loadCollections,
  loadInterests,
  loadRelated,
  selectTab,
  slideDidBecomeVisible
}

// Action dispatchers

function loadCollections({ article, nextUrl }) {
  const urlId = article['url_id']
  const options = nextUrl ? { nextUrl } : undefined
  return async function (dispatch) {
    dispatch({
      type: COLLECTIONS_LOADING,
      payload: { urlId }
    })
    try {
      const { curator, items, meta } =
        await ArticleAPI.fetchUrlMixHistoryV2(urlId, options)
      if (!nextUrl) {
        dispatch({
          type: COLLECTIONS_RESET,
          payload: { urlId }
        })
      }
      dispatch({
        type: COLLECTIONS_LOADED,
        payload: { items, meta, urlId }
      })
      if (curator) {
        dispatch({
          type: CURATOR_LOADED,
          payload: { ...curator, urlId }
        })
      }
    } catch (err) {
      dispatch({
        type: COLLECTIONS_FAILED,
        payload: { urlId }
      })
      throw err
    }
  }
}

function loadInterests({ article }) {
  const urlId = article['url_id']
  return async function (dispatch) {
    dispatch({
      type: INTERESTS_LOADING,
      payload: { urlId }
    })
    try {
      const { interests: items } =
        await ArticleAPI.fetchInterests(article.hash)
      dispatch({
        type: INTERESTS_LOADED,
        payload: { items, urlId }
      })
    } catch (err) {
      dispatch({
        type: INTERESTS_FAILED,
        payload: { urlId }
      })
      throw err
    }
  }
}

function loadRelated({ article, nextUrl }) {
  return async function (dispatch) {
    const urlId = article['url_id']
    const options = { limit: 12, nextUrl }
    dispatch({
      type: RELATED_LOADING,
      payload: { urlId }
    })
    try {
      const { items, meta } =
        await ArticleAPI.fetchRelatedArticles(urlId, options)
      dispatch({
        type: RELATED_LOADED,
        payload: { items, meta, urlId }
      })
    } catch (err) {
      dispatch({
        type: RELATED_FAILED,
        payload: { urlId }
      })
      throw err
    }
  }
}

function fetchSlideDetails(slide) {
  const urlId = slide.article['url_id']
  // eslint-disable-next-line complexity
  return async function (dispatch) {
    const query = {}
    if (needsFetch(slide.articleState)) {
      query.article = true
    }
    if (needsFetch(slide.collectionsState)) {
      query.history = true
      dispatch({
        type: COLLECTIONS_LOADING,
        payload: { urlId }
      })
    }
    if (needsFetch(slide.interestsState)) {
      query.interests = true
      dispatch({
        type: INTERESTS_LOADING,
        payload: { urlId }
      })
    }
    if (!slide.relatedStream) {
      query.related = true
      dispatch({
        type: RELATED_LOADING,
        payload: { urlId }
      })
    }
    try {
      const queryString = qs.stringify(query)
      const result = await ajax({
        url: `/api/v0.1/url/${urlId}/article-profile-slide-details?${queryString}`
      })
      if (result.article) {
        dispatch(articleModelActions.articleUpdated(result.article))
      }
      if (result.history) {
        const { curator, items, meta } = result.history
        dispatch({
          type: COLLECTIONS_LOADED,
          payload: { items, meta, urlId }
        })
        if (curator) {
          dispatch({
            type: CURATOR_LOADED,
            payload: { ...curator, urlId }
          })
        }
      }
      if (result.interests) {
        const items = result.interests
        dispatch({
          type: INTERESTS_LOADED,
          payload: { items, urlId }
        })
      }
      if (result.related) {
        const { items, meta } = result.related
        dispatch({
          type: RELATED_LOADED,
          payload: { items, meta, urlId }
        })
      }
    } catch (err) {
      if (query.history) {
        dispatch({
          type: COLLECTIONS_FAILED,
          payload: { urlId }
        })
      }
      if (query.interests) {
        dispatch({
          type: INTERESTS_FAILED,
          payload: { urlId }
        })
      }
      if (query.related) {
        dispatch({
          type: RELATED_FAILED,
          payload: { urlId }
        })
      }
      throw err
    }
  }
}

function slideDidBecomeVisible({ slide, pageContext = {} }) {
  return function (dispatch) {
    dispatch(fetchSlideDetails(slide))
    dispatch(articleModelActions.trackCardView({
      article: slide.article,
      pageContext
    }))
  }
}

// Action creators

function selectTab({ article, selectedTab }) {
  const urlId = article['url_id']
  return {
    type: SELECT_TAB,
    payload: { selectedTab, urlId }
  }
}

// Internal helpers

function needsFetch(fetchState) {
  return fetchState === FetchStateEnum.EMPTY
}
